import { DotsStyled } from './Dots.styled';

const Dots = ({ dotsNum, selected }) => {
    const arrForRender = new Array(dotsNum).fill('');

    const renderDots = i => {
        if (selected === i+1) return <div key={i} className='selected-dot'></div>
        else return <div key={i} className='not-selected-dot'></div>      
    };

    return (
        <DotsStyled>{arrForRender.map((_, i) => renderDots(i))}</DotsStyled>
    )
}

export default Dots;